module.exports = __webpack_public_path__ + "static/together_event02_icon01-ad08a214c389f70501cfbd272e1f6392.png";